<template>
  <v-dialog
    :value="true"
    fullscreen
    scrollable
  >
    <v-card>
      <v-card-title
        class="px-1 py-3"
      >
        <v-btn
          icon
          color="primary"
          @click="$router.push('/inbox')"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title>{{ you.nickname }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu
          bottom
          left
          offset-y
          v-if="you.uid != paikeSupport.uid"
        >
          <template
            v-slot:activator="{ on }"
          >
            <v-btn
              icon
              v-on="on"
              color="primary"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <!-- Menu:Block -->
            <v-list-item
              @click="blockDialog.isShow = true"
            >
              <v-list-item-title>
                Block
              </v-list-item-title>
            </v-list-item>
            <!-- Menu:Report -->
            <v-list-item
              @click="doReport"
            >
              <v-list-item-title>
                Report
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>
      <v-card-text
        ref="messageList"
      >
        <div
          v-for="(item, index) in chatList"
          :key="index"
          class="pt-2"
        >
          <div
            v-if="item.uid == 'date'"
            class="date-frame"
          >
            <div
              v-text="item.date"
            >
            </div>
          </div>
          <div
            v-else
            class="item"
          >
            <div
              :class="item.uid == you.uid ? 'you-comment' : 'me-comment'"
            >
              <img
                v-if="item.uid == you.uid"
                class="avatar"
                @click="$router.push(`/profile/${you.uid}`)"
                :src="you.photoUrl"
              />
              <div
                v-else
                class="time"
              >
                {{ item.read }}<br />
                {{ item.time }}
              </div>
              <div
                class="comment"
              >
                <div v-html="item.comment"></div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-form
        ref="commentForm"
        @submit.prevent
      >
        <v-card-actions>
          <v-textarea
            v-model="comment"
            :rules="[required]"
            :disabled="process"
            placeholder="Write a message"
            auto-grow
            rows="1"
            row-height="15"
          ></v-textarea>
          <span
            :disabled="process"
            :loading="process"
            @click.stop="doSend"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
              d="M3.67148 20.4005L21.1215 12.9205C21.9315 12.5705 21.9315 11.4305 21.1215 11.0805L3.67148 3.60051C3.01148 3.31051 2.28148 3.80051 2.28148 4.51051L2.27148 9.12051C2.27148 9.62051 2.64148 10.0505 3.14148 10.1105L17.2715 12.0005L3.14148 13.8805C2.64148 13.9505 2.27148 14.3805 2.27148 14.8805L2.28148 19.4905C2.28148 20.2005 3.01148 20.6905 3.67148 20.4005Z"
              :fill="process ? '#666666' : '#FF5500'"/>
            </svg>
          </span>
        </v-card-actions>
      </v-form>
    </v-card>

    <!-- Block Confirm Dialog -->
    <v-dialog
      v-model="blockDialog.isShow"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title>
          Confirmation😊
        </v-card-title>
        <v-card-text>
          Block this person?🚧
          By blocking this person, they won't be able to search for you or talk to you.
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            :loading="blockDialog.process"
            :disabled="blockDialog.process"
            @click="doBlock"
          >OK</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            :loading="blockDialog.process"
            :disabled="blockDialog.process"
            @click="blockDialog.isShow = false"
          >Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Report Dialog -->
    <report
      ref="reportDialog"
      :fromUid="me.uid"
      :toUid="you.uid"
      :rid="rid"
    ></report>

    <!-- MessageBox -->
    <messageBox
      ref="msgBox"
    ></messageBox>
  </v-dialog>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import firebase from "firebase/app"
import "firebase/firestore"
import "firebase/auth"
import MessageBox from '@/components/MessageBox'
import Report from '@/components/Like/Report'
import service from '@/plugins/service'

export default {
  components: {
    MessageBox,
    Report,
  },
  data: () => ({
    uid: '',
    rid: '',
    room: {
      rid: '',
    },
    you: {
      uid: '',
      nickname: '',
      photoUrl: '',
    },
    me: {
      uid: '',
      nickname: '',
      photoUrl: '',
    },
    blockDialog: {
      isShow: false,
      process: false,
    },
    paikeSupport: {
      uid: '',
      photoUrl: '',
      nickname: '',
    },
    chatList: [],
    comment: [],
    process: false,
    required: value => !!value || 'Required',
    messageSnapshot: () => {},
    dayOfWeekStr: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  }),
  async mounted() {
    const rid = this.$route.params.rid
    const uid = this.$route.params.uid
    let user = {}
    try {
      user = await service.authCheck()
    } catch (e) {
      if (rid) {
        this.$router.replace(`/signIn/room/${rid}`)
      } else if (uid) {
        this.$router.replace(`/signIn/paikeout/${uid}`)
      }
      return
    }
    // Profile完成確認
    const isProfileComplete = await service.isProfileComplete(user.uid)
    if (!isProfileComplete) {
      // MyProfile完成していない場合はMyProfileに強制的に飛ばす
      if (rid) {
        this.setNextRoute(`/room/${rid}`)
      } else if (uid) {
        this.setNextRoute(`/paikeout/${uid}`)
      }
      this.$router.replace('/myProfile')
      return
    }
    // PaikeSupportはBlockできないように。
    this.paikeSupport = await service.getPaikeoutSupportInfo()
    const db = firebase.firestore()
    this.uid = user.uid
    if (rid) {
      this.rid = rid
    } else if (uid && uid != this.uid) {
      this.rid = await this.getRoomId(uid)
    } else {
      this.$refs.msgBox.show(
        'Message.',
        `Unfortunately, you can't paike out with yourself😆`,
        'OK',
        () => {
          this.$router.push('/likes')
        },
      )
      return
    }
    this.room = db.collection('rooms').doc(this.rid)
    const roomDoc = await this.room.get()
    const roomData = roomDoc.data()
    if (roomData.deleteFlag) {
      this.$refs.msgBox.show(
        'Notice',
        `Sorry. You can't chat with this person.`,
        'OK',
        () => {
          this.$router.push('/likes')
        },
      )
      return
    }
    // 相手
    let hasMe = false
    roomData.uids.forEach((u) => {
      if (u != this.uid) {
        this.you.uid = u
      } else {
        hasMe = true
      }
    })
    if (!hasMe) {
      // 自分がいない時はChatRoomが見えてはいけない
      this.$refs.msgBox.show(
        'Oops!',
        `You cannot see other’s message!`,
        'OK',
        () => {
          this.$router.push('/likes')
        }
      )
      return
    }
    // 自分
    await this.setUserInfo(this.uid, this.me)
    if (roomData.latestUid != this.uid) {
      // 最終更新が自分でないときは既読にする
      await this.room.set({ isReaded: true }, { merge: true })
    }
    // 相手の情報
    await this.setUserInfo(this.you.uid, this.you)
    // サービスの既読更新
    await service.readComment(this.rid, this.you.uid, this.me.uid)
    const chatList = this.chatList
    const app = this
    this.messageSnapshot = db.collection(`rooms/${this.rid}/comments`)
        .orderBy('created', 'asc')
        .onSnapshot(snapshot => {
      chatList.splice(0)
      let lastDate = ''
      snapshot.forEach((doc) => {
        const dat = doc.data()
        let time = ''
        if (!!dat.created && !!dat.created.seconds) {
          const sec = dat.created.seconds
          const dt = new Date(sec * 1000)
          let year = dt.getFullYear()
          let month = dt.getMonth() + 1
          let day = dt.getDate()
          let dayOfWeek = this.dayOfWeekStr[dt.getDay()]
          const currentDate = `${month}/${day}(${dayOfWeek})`
          if (!lastDate || lastDate != currentDate) {
            chatList.push({
              date: currentDate,
              uid: 'date',
            })
          }
          lastDate = currentDate
          let min = dt.getMinutes()
          let hour = dt.getHours()
          let amPm = 'AM'
          if (min < 10) {
            min = '0' + min
          }
          if (hour > 11) {
            hour -= 12
            amPm = 'PM'
          }
          time = `${amPm}${hour}:${min}`
        }
        chatList.push({
          comment: dat.comment.replace(/\n/g, '<br />'),
          created: dat.created,
          time: time,
          read: '',
          uid: dat.uid,
        })
      })
      // 既読更新
      setTimeout(() => {
        service.readComment(this.room.rid, this.you.uid, this.me.uid)
      }, 1000)
      // 一番下にスクロール
      app.scrollToEnd()
    })
  },
  methods: {
    ...mapActions('storage', [
      'setNextRoute',
    ]),
    async addComment(room, uid, comment, toUid) {
      const doc = room.collection('comments').doc()
      await doc.set({
        uid: uid,
        comment: comment,
        created: firebase.firestore.FieldValue.serverTimestamp(),
      })
      await room.set({
        latestUid: uid,
        latestComment: comment,
        isReaded: false,
        modified: firebase.firestore.FieldValue.serverTimestamp(),
      }, { merge: true })
      // 更新通知送信用にサービスに蓄積
      await service.addComment(this.rid, uid, toUid, doc.id, comment)
      // サービスの既読更新
      await service.readComment(this.rid, toUid, uid)
    },
    async setUserInfo(uid, to) {
      const userInfo = await service.getUserInfo(uid);
      to.uid = uid
      to.nickname = userInfo.nickname
      to.photoUrl = userInfo.photoUrl
    },
    async doSend() {
      if (this.process) {
        return
      }
      if (!this.$refs.commentForm.validate()) {
        return
      }
      this.process = true
      try {
        await this.addComment(this.room, this.uid, this.comment, this.you.uid)
        this.$refs.commentForm.reset()
      } catch (e) {
        alert(e)
      } finally {
        this.process = false
      }
    },
    async getRoomId(uid) {
      const db = firebase.firestore()
      // 二人のチャットルームがあるかどうか
      const rooms = await db.collection('rooms')
        .where('uids', 'array-contains', this.uid)
        .get()
      let room = undefined
      rooms.forEach((doc) => {
        const data = doc.data()
        if (data.uids.length == 2 && data.uids.includes(uid)) {
          room = doc
        }
      })
      if (room) {
        // 存在したら、そのroomを返す
        return room.id
      }
      // 無いときはチャットルーム作って、そのridを返す
      room = db.collection('rooms').doc()
      await room.set({
        uids: [this.uid, uid],
        createUid: this.uid,
      })
      // 初回書き込み
      if (this.paikeSupport.uid == uid) {
        this.addComment(room, uid, `Hello! We are Paike Support Team and here to help you😊
Please let us know if you have any questions by replying to this message👍`, this.uid)
      } else {
        this.addComment(room, this.uid, 'Hello!😊', uid)
      }
      return room.id
    },
    scrollToEnd() {
      try {
        this.$nextTick(() => {
          let currentHeight = this.$refs.messageList
          currentHeight.scrollTo(0, 1000000)
        })
      } catch (e) {
        service.log(e)
      }
    },
    async doBlock() {
      this.blockDialog.process = true
      try {
        // Roomに削除フラグを立てる
        this.room.set({
          deleteFlag: true,
        }, {
          merge: true,
        })
        this.$refs.msgBox.show(
          'Confirmation😊',
          'Block is completed🚧',
          'OK',
          () => {
            this.$router.push('/inbox')
          },
        )
        // Bookmark削除のため、Block処理を呼び出す
        await service.doBlock(this.me.uid, this.you.uid)
        this.blockDialog.isShow = false
      } finally {
        this.blockDialog.process = false
      }
    },
    doReport() {
      this.$refs.reportDialog.show()
    },
  },
  beforeRouteLeave(to, from, next) {
    try {
      // snapshotを開放
      this.messageSnapshot()
    } catch (e) {
      service.log('message snapshot terminate failed.')
      service.log(e)
    } finally {
      next()
    }
  },
}
</script>

<style lang="stylus" scoped>
.content-me
  margin-top 5px
  margin-right -10px;
  color white
  background-color #ed612b
  border-radius 20px / 20px

.content-you
  margin-top 5px
  margin-left -10px;
  color black
  background-color #f8d6c2
  border-radius 20px / 20px

div.date-frame
  margin -8px auto 8px auto
  text-align center
  div
    display inline-block
    background #EAE9E9
    opacity 0.7
    border-radius 32px
    height 24px
    padding 2px 8px
    color #0C0B0B !important
    font-style normal
    font-weight normal
    line-height 20px
    text-align center

div.item
  position static
  margin-bottom 16px
  div.you-comment
    position relative
    margin-bottom 16px
    img.avatar
      position absolute
      top 0
      left 0
      width 40px
      height 40px
      border-radius 20px
    div.comment
      position relative
      top 0
      left 56px
      width calc(100% - 56px - 11px)
      color #0C0B0B
      background-color #FFD5BF
      border-radius 24px
      padding 16px
      font-style normal
      font-weight normal
      font-size 14px
      line-height 20px


  div.me-comment
    position: relative
    margin-bottom 16px
    div.time
      position absolute
      bottom 0
      right calc(100% - 75px + 8px)
      color #0C0B0B
      text-align right
    div.comment
      position relative
      top 0
      left 75px
      width calc(100% - 75px)
      color #FFFFFF
      background-color #FF5500
      border-radius 24px
      padding 16px
      font-style normal
      font-weight normal
      font-size 14px
      line-height 20px

</style>
